module.exports = __webpack_public_path__ + "img/anonymous-person-f.033a6ae.png";